export default {
  installed: 'Installed',
  notInstalled: 'Addons is not installed',
  addons: 'Addons'
}
